import Get from '../services/Get';
import Delete from '../services/Delete';
import PostFormData from '../services/PostFormData';
import PutFormData from '../services/PutFormData';

import { nexcareVersion } from '../config/serviceConfig';

const getListNewsFeedInitiate = (token) => Get(`/${nexcareVersion}/nexcare/kms/initiate?filter=kms.type eq N&is_newfeeds=true`, token);
const getListNewsFeed = (page, limit, sorter, token) => Get(`/${nexcareVersion}/nexcare/kms?page=${page}&limit=${limit}&order=kms.id ${sorter}&filter=kms.type eq N&is_newfeeds=true`, token);

const getListNewsFeedSearchInitiate = (key, token) => Get(`/${nexcareVersion}/nexcare/kms/initiate?keyword=${key}&filter=kms.type eq N&is_newfeeds=true`, token);
const getListNewsFeedSearch = (page, limit, sorter, key, token) => Get(`/${nexcareVersion}/nexcare/kms?page=${page}&limit=${limit}&order=kms.id ${sorter}&keyword=${key}&filter=kms.type eq N&is_newfeeds=true`, token);

const getDetailNewsFeed = (id, token) => Get(`/${nexcareVersion}/nexcare/kms/${id}`, token);
const postDataAddNewsFeed = (data, token) => PostFormData(`/${nexcareVersion}/nexcare/kms`, data, token);
const putDataEditNewsFeed = (id, data, token) => PutFormData(`/${nexcareVersion}/nexcare/kms/${id}`, data, token);
const deleteDataNewsFeed = (id, data, token) => Delete(`/${nexcareVersion}/nexcare/kms/${id}`, data, token);

const API_NEWS_FEED = {
    getListNewsFeedInitiate,
    getListNewsFeed,
    getListNewsFeedSearchInitiate,
    getListNewsFeedSearch,
    getDetailNewsFeed,
    postDataAddNewsFeed,
    putDataEditNewsFeed,
    deleteDataNewsFeed

}

export default API_NEWS_FEED;